import React from 'react'

import LoadingBox from 'src/ui/LoadingBox/LoadingBox'

import MasonryGrid from './MasonryGrid'
const placeholderItems = Array.from({ length: 9 }).map((_, index) => ({
  id: index.toString(),
}))

const renderGridContent = () => {
  return (
    <LoadingBox
      borderRadius="1x"
      width="100%"
      height={Math.floor(Math.random() * 200) + 100 + 'px'}
    />
  )
}

const MasonryGridPlaceholder = () => (
  <MasonryGrid items={placeholderItems} renderGridContent={renderGridContent} />
)

export default MasonryGridPlaceholder
